var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"building-tree"},[_c('el-tree',{attrs:{"data":_vm.data,"node-key":"id","default-expand-all":"","expand-on-click-node":false},scopedSlots:_vm._u([{key:"default",fn:function(ref){
var node = ref.node;
var data = ref.data;
return _c('div',{staticClass:"custom-tree-node",class:_vm.checking && _vm.validateInput(node, data) ? 'error-input' : ''},[_c('span',{staticClass:"mr-5"},[_vm._v(_vm._s(data.type === 'building'
          ? _vm.$t('text.facility')
          : data.type === 'floor'
          ? _vm.$t('text.floor')
          : _vm.$t('text.room')))]),_c('el-input',{attrs:{"size":"mini","placeholder":data.type === 'building'
            ? _vm.$t('text.facility_name')
            : data.type === 'floor'
            ? _vm.$t('text.floor_name')
            : _vm.$t('text.room_number')},model:{value:(data.label),callback:function ($$v) {_vm.$set(data, "label", $$v)},expression:"data.label"}}),(_vm.checking && _vm.validateInput(node, data))?_c('span',{staticClass:"error-text"},[_vm._v(_vm._s(_vm.validateInput(node, data)))]):_vm._e()],1)}}])})],1)}
var staticRenderFns = []

export { render, staticRenderFns }